// modais
import UserModal from "../../components/UserModal";
import DeleteUserModal from "../../components/User/deleteUserModal";

// icones
import SearchIcon from "@material-ui/icons/Search";
import MainContainer from "../../components/MainContainer";
import AddOutlinedIcon from '@material-ui/icons/AddOutlined';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined';

// utilitarios
import { Avatar, Box, Button, FormControl, Grid, InputAdornment, Menu, MenuItem, Select, TextField, CheckBox, Chip, Fade, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TableSortLabel, Tooltip, Typography, Switch } from "@material-ui/core";
import { Alert, AlertTitle } from '@material-ui/lab';
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React, { useContext, useEffect, useReducer, useState } from "react";
import { toast } from "react-toastify";
import TableRowSkeleton from "../../components/TableRowSkeleton";
import toastError from "../../errors/toastError";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";
import { AuthContext } from "../../context/Auth/AuthContext";
import socket from "../../hooks/useSocket";
import SingleSelect from "../../components/InputStyled/singleSelect";

const initialState = [];

const reducer = (state = initialState, action) => {
  if (action.type === "LOAD_USERS") {
    const users = action.payload;
    return !users ? [] : users;
  }

  if (action.type === "UPDATE_USERS") {
    let { user } = action.payload;
    if (!user) user = action.payload;
    if (!user) return;

    const userIndex = state.findIndex((u) => u.id === user.id);

    if (userIndex !== -1) {
      state[userIndex] = user;
      return [...state];
    } else {
      return [user, ...state];
    }
  }

  if (action.type === "DELETE_USER") {
    const userId = action.payload;

    const userIndex = state.findIndex((u) => u.id === userId);
    if (userIndex !== -1) {
      state.splice(userIndex, 1);
    }
    return [...state];
  }

  if (action.type === "RESET") {
    return [];
  }
};

const descendingComparator = (a, b, orderBy) => {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

const getComparator = (order, orderBy) => {
  return order === "desc"
    ? (a, b) => descendingComparator(String(a).toLowerCase(), String(b).toLowerCase(), orderBy)
    : (a, b) => -descendingComparator(String(a).toLowerCase(), String(b).toLowerCase(), orderBy);
}

const stableSort = (array, comparator) => {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  {
    id: "name",
    disablePadding: true,
    label: i18n.t("users.table.name"),
    sortable: true,
  },
  {
    id: "email",
    disablePadding: false,
    label: i18n.t("users.table.email"),
    sortable: true,
  },
  {
    id: "profile",
    disablePadding: false,
    label: i18n.t("users.table.profile"),
    sortable: true,
  },
  {
    id: "status",
    disablePadding: false,
    label: i18n.t("users.table.status"),
    sortable: true,
  },
  {
    id: "actions",
    numeric: true,
    disablePadding: false,
    label: i18n.t("users.table.actions"),
    sortable: false,
  },
];

const EnhancedTableHead = (props) => {
  const {
    classes,
    order,
    orderBy,
    rowCount,
    onRequestSort,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <>
      <TableHead>
        <TableRow>
          {headCells.map((headCell) => {
            const isSortable = headCell.sortable !== false; // Verifica se a coluna é ordenável
            return (
              <TableCell
                key={headCell.id}
                align="left"
                padding={headCell.disablePadding ? "none" : "normal"}
                sortDirection={
                  isSortable && orderBy === headCell.id ? order : false
                }
              >
                {isSortable ? (
                  <TableSortLabel
                    active={orderBy === headCell.id}
                    direction={orderBy === headCell.id ? order : "asc"}
                    onClick={createSortHandler(headCell.id)}
                  >
                    {headCell.label}
                    {orderBy === headCell.id ? (
                      <span className={classes.visuallyHidden}>
                        {order === "desc"
                          ? "sorted descending"
                          : "sorted ascending"}
                      </span>
                    ) : null}
                  </TableSortLabel>
                ) : (
                  headCell.label // Sem TableSortLabel para colunas não ordenáveis
                )}
              </TableCell>
            );
          })}
        </TableRow>
      </TableHead>
    </>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useStyles = makeStyles((theme) => ({
  mainPaper: {
    flex: 1,
    padding: theme.spacing(1),
    overflowY: "scroll",
    ...theme.scrollbarStyles,
  },
  modalStyle: {
    padding: "20px",
    maxheight: "95vh!important",
    minWidth: "670px",
    background: "#ffffff",
    marginTop: "10px",
    marginLeft: "10px",
    marginRight: "10px",
    borderRadius: "10px",
    boxShadow: "0 2px 2px 0 rgba(0,0,0,0.14),0 3px 1px -2px rgba(0,0,0,0.12),0 1px 5px 0 rgba(0,0,0,0.2)",
    "@media (max-width: 740px)": {
      padding: "0px !important",
      marginTop: "65px",
    }
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  searchInput: {
    float: "right",
    marginRight: "10px",
    "&>div": {
      backgroundColor: "rgba(0,0,0,0)",
      height: "38px",
      lineHeight: "38px",
      "&>div": {
        marginTop: "0!important"
      }
    },
    "& input": {
      height: "38px",
      lineHeight: "38px",
      padding: "0"
    }
  },
  addButton: {
    float: "right",
    height: "38px"
  }
}));

export default function EnhancedTable() {
  const { user } = useContext(AuthContext);
  const classes = useStyles();

  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("name");
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [searchParam, setSearchParam] = useState("");
  const [enterSearchParam, setEnterSearchParam] = useState(null);
  const [loading, setLoading] = useState(false);
  const [users, dispatch] = useReducer(reducer, []);
  const [total, setTotal] = useState(0);
  const [selectedUser, setSelectedUser] = useState(null);
  const [userModalOpen, setUserModalOpen] = useState(false);

  const [disableModalOpen, setDisableModalOpen] = useState(false);
  const [userStatus, setUserStatus] = useState("true");
  const [currentEnabledUsers, setCurrentEnabledUsers] = useState([]);
  const totalPages = Math.ceil(total / rowsPerPage);

  const FilteredUser = (usr) => {

    if (usr.adminId != user.adminId) return false;

    if (!usr) return false;

    // se estiver pesquisando não atualizar
    if (enterSearchParam && enterSearchParam != "" && enterSearchParam != "undefined") return false;

    // verificar status
    if ((userStatus == "true" && usr?.status != true) || (userStatus == "false" &&  usr?.status != false)) return false;

    return true;
  }

  useEffect(() => {
    let isMounted = true;
    const abortController = new AbortController();

    // criar validação se possuí licenças de usuários
    (async () => {
      try {
        const { data: userList } = await api.get(`/usersList`, {
          signal: abortController.signal,
        });
        if (!isMounted) return;

        if (Array.isArray(userList)) {
          setCurrentEnabledUsers(userList.filter(u => u.status == true).map(u => u.id));
          return;
        }

      } catch (err) {
        if (!isMounted || err.name == 'AbortError') return;
        console.error({ err });
        toastError(err);
      }
    })();

    return () => {
      isMounted = false;
      abortController.abort();
    };
  }, []);

  useEffect(() => {
    const userEventName = 'user';
    const userEventFunction = async (data) => {
      if (data.action === "update" || data.action === "create") {
        if (FilteredUser(data.user) == true) {
          dispatch({ type: "UPDATE_USERS", payload: data.user });
        } else {
          // se não passou no filtro e existe na lista atual, remover
          const uIdx = users.findIndex(u => u.id == data?.user?.id);
          if (uIdx != -1) {
            dispatch({ type: "DELETE_USER", payload: +data.user.id });
          }
        }

        setCurrentEnabledUsers(prev => {
          const userId = +data.user.id;
          if (data?.user?.status == true) {
            return prev.includes(userId) ? prev : [...prev, userId];
          } else {
            return prev.filter(id => id != userId);
          }
        });
      }

      if (data.action === "delete") {
        dispatch({ type: "DELETE_USER", payload: +data.userId });
        setCurrentEnabledUsers(prev => prev.filter(u => u !== +data.userId));
      }
    };
    socket.on(userEventName, userEventFunction);

    return () => {
      socket.off(userEventName, userEventFunction);
    };
  }, [ , user, users]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  useEffect(() => {

    let isMounted = true;
    const abortController = new AbortController();

    (async () => {
      try {
        setLoading(true);
        const { data } = await api.get("/users/", {
          params: {
            page,
            rowsPerPage,
            order,
            orderBy,
            searchParam,
            userStatus
          },
          signal: abortController.signal,
        });
        if (!isMounted) {
          setLoading(false);
          return;
        }
        dispatch({ type: "LOAD_USERS", payload: data.users }); // Verifique se o payload é o esperado
        setTotal(data.total);
      } catch (err) {
        if (!isMounted || err.name == 'AbortError') {
          setLoading(false);
          return;
        }
        console.error(err);
        toastError(err);
      } finally {
        setLoading(false);
      }
    })();
  }, [, page, rowsPerPage, order, orderBy, enterSearchParam, userStatus]);

  const handleChangePage = (event, newPage) => {
    // Verifica se a nova página está dentro dos limites
    if (newPage < 0) {
      setPage(1);
    } else if (newPage >= totalPages) {
      setPage(totalPages - 1);
    } else {
      setPage(newPage);
    }
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  const searchByText = () => {
    if (!searchParam || searchParam == "undefined") return;
    setEnterSearchParam(!enterSearchParam);
  }

  const handleSearch = (event) => {
    if (event.key == "Enter") {
      searchByText();
      return;
    }

    let str = String(event.target.value).trim().toLowerCase();
    if (str == "undefined") str = "";

    setSearchParam(str);
    if (str == "" || str == null) searchByText();

  };

  const handleOpenUserModal = () => {
    setSelectedUser(null);
    setUserModalOpen(true);
  };

  const handleCloseUserModal = () => {
    setSelectedUser(null);
    setUserModalOpen(false);
  };

  const handleEditUser = (user) => {
    setSelectedUser(user);
    setUserModalOpen(true);
  };

  const handleDisableUser = (user) => {
    setSelectedUser(user);
    setDisableModalOpen(true);
  };

  const handleCloseDisableUser = () => {
    setSelectedUser(null);
    setDisableModalOpen(false);
  };

  const handleUserStatus = async (userId, status) => {
    try {
      // resgatar filas da conexão e usuário
      setLoading(true);
      const { data } = await api.post(`/user/updateStatus/${userId}`, {
        status: status == true ? true : false
      });
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.error({ err });
      toastError(err);
    }
  }

  return (
    <>
      <Box component="div" className={classes.modalStyle} id="box">
        <Grid container spacing={2}>
          <Grid item xs={12} mb={2}>
            <Typography variant="h5" style={{ fontWeight: "600" }}>{i18n.t("users.title")}</Typography>
          </Grid>
        </Grid>

        <Grid container spacing={2}>
          <Grid item xs={12} mb={2}>
            <Alert icon={false} severity="info">
              <AlertTitle style={{ fontSize: "1.3rem" }}>{i18n.t("users.license.title")}</AlertTitle>
              <Typography variant="h6" style={{ fontSize: "1rem", display: "inline-block", marginRight: "5px" }}>{`${i18n.t("users.license.licensesContracted")}: ${user?.company?.maxUsers}`}</Typography>
              <Typography variant="h6" style={{ fontSize: "1rem", display: "inline-block", marginRight: "5px" }}>{`${i18n.t("users.license.usedLicenses")}: ${currentEnabledUsers.length}`}</Typography>
              <Typography variant="h6" style={{ fontSize: "1rem", display: "inline-block", marginRight: "5px" }}>{`${i18n.t("users.license.availableLicenses")}: ${!isNaN(user?.company?.maxUsers) ? user?.company?.maxUsers - currentEnabledUsers.length : 0}`}</Typography>
            </Alert>
          </Grid>
        </Grid>

        <Grid container spacing={2}>
          <Grid item xs={12} mb={2}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleOpenUserModal}
              className={classes.addButton}
            >
              <AddOutlinedIcon />
              {i18n.t("users.buttons.add")}
            </Button>
            <TextField
              placeholder={i18n.t("users.search")}
              variant="filled"
              type="search"
              value={searchParam}
              background="transparent"
              className={classes.searchInput}
              onKeyDown={handleSearch}
              onChange={handleSearch}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon style={{ color: "gray" }} onClick={searchByText} />
                  </InputAdornment>
                ),
              }}
            />
            <SingleSelect
              closeOnSelect={true}
              disabled={false}
              displayText={i18n.t("users.table.selectStatus")}
              title={undefined}
              options={[{ key: 'false', value: i18n.t("users.table.disabled"), disabled: false }, { key: 'true', value: i18n.t("users.table.enabled"), disabled: false }]}
              key={`selectStatusUserFilter`}
              onSelected={(status) => {
                setUserStatus(status);
              }}
              selected={userStatus}
              style={{
                width: "200px",
                float: "right",
                marginRight: "10px",
                height: "38px",
                lineHeight: "38px",
              }}
            />
          </Grid>
        </Grid>

        <Grid container spacing={2}>
          <Grid item xs={12} mb={2}>
            <TableContainer>
              <Table
                className={classes.table}
                aria-labelledby="tableTitle"
                size="medium"
                aria-label="enhanced table"
              >
                <EnhancedTableHead
                  classes={classes}
                  order={order}
                  orderBy={orderBy}
                  onRequestSort={handleRequestSort}
                  rowCount={users?.length || 0}
                />
                {loading ? (
                  <TableBody>
                    <TableRowSkeleton avatar columns={4} />
                  </TableBody>
                ) : (
                  <TableBody>
                    {!users || users?.length == 0 ? (
                      <TableRow>
                        <TableCell
                          colSpan={headCells.length}
                          align="center"
                        >
                          {i18n.t('users.table.notFound')}
                        </TableCell>
                      </TableRow>
                    ) : (
                      stableSort(
                        users,
                        getComparator(order, orderBy)
                      ).map((row, index) => {
                        const labelId = `enhanced-table-checkbox-${index}`;

                        return (
                          <TableRow
                            hover
                            role="checkbox"
                            tabIndex={-1}
                            key={row.id}
                            style={{
                              position: "relative",
                              height: "70px",
                            }}
                          >
                            <TableCell align="left">{row.name}</TableCell>
                            <TableCell align="left">{row.email}</TableCell>
                            <TableCell align="left">{row.profile}</TableCell>
                            <TableCell align="left">
                              <Switch
                                checked={row?.status == true ? true : false}
                                onChange={() => {
                                  if (row?.status == true) {
                                    handleDisableUser(row);
                                    return;
                                  } else {
                                    handleUserStatus(row.id, row.status == true ? false : true);
                                    return;
                                  }
                                }}
                                color="primary"
                                name={`changeStatus-${row.id}`}
                              />
                            </TableCell>
                            <TableCell style={{ width: 195 }}>
                              <Button
                                title={i18n.t('buttons.edit')}
                                onClick={() => {
                                  if (row.status == false) return;
                                  handleEditUser(row);
                                }}
                                disabled={row.status == false}
                              >
                                <EditOutlinedIcon />
                              </Button>
                            </TableCell>
                          </TableRow>
                        );
                      })
                    )}
                  </TableBody>
                )}
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[20, 50, 100]}
              component="div"
              count={total}
              rowsPerPage={rowsPerPage}
              page={page - 1}
              labelRowsPerPage={i18n.t("users.table.resultPerPage")}
              labelDisplayedRows={({ from, to, count }) =>
                `${i18n.t("users.table.total")} ${count} / ${i18n.t("users.table.of")} ${from} ${i18n.t("users.table.to")} ${to}`
              }
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Grid>
        </Grid>
      </Box>
      <UserModal
        open={userModalOpen}
        onClose={handleCloseUserModal}
        aria-labelledby="form-dialog-title"
        userId={selectedUser && selectedUser.id}
        userEditing={user.id}
      />
      <DeleteUserModal
        userId={selectedUser?.id || undefined}
        open={disableModalOpen}
        onClose={handleCloseDisableUser}
      />
    </>
  );
};